import { createAction, props } from '@ngrx/store';

import { SpeechTab } from '../../../customization/components/speech/speech-container/interfaces';
import { SpeechPermission } from '../../interfaces';

export const selectSpeechTab = createAction('[SpeechPage] select tab', props<{ tab: SpeechTab }>());
export const initSelectedSpeechTab = createAction('[SpeechPage] init selected tab', props<{ tab: SpeechTab }>());
export const initSpeechPagePermission = createAction('[SpeechPage] init speech page permission', props<{ permission: SpeechPermission }>());
